<template>
<div
  :key="item.id"
  class="image-block"
  :class="{ 'image-block_half': item.type == 'half' }"
>
  <div>
    <div
      class="image-block__image-wrapper"
      :class="{ 'image-block__image-wrapper_half': item.type == 'half' }"
    >
      <validation-provider
        slim
        :vid="`${item.id + 1}`"
        rules="image|size:10240"
        v-slot="{ errors }"
      >
        <preview-image-input
          v-model="item.images[0].file"
          :providedPreview="item.images[0].url"
          :error="errors.length > 0"
        ></preview-image-input>
      </validation-provider>
    </div>
  </div>
  <div>
    <div
      v-if="item.type == 'half'"
      class="image-block__image-wrapper"
      :class="{ 'image-block__image-wrapper_half': item.type == 'half' }"
    >
      <validation-provider
        slim
        :vid="`${item.id + 2}`"
        rules="image|size:10240"
        v-slot="{ errors }"
      >
        <preview-image-input
          v-model="item.images[1].file"
          :providedPreview="item.images[1].url"
          :error="errors.length > 0"
        ></preview-image-input>
      </validation-provider>
    </div>
  </div>
</div>
</template>

<script>
import PreviewImageInput from '../components/PreviewImageInput'

import { ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import { image, size } from 'vee-validate/dist/rules'
extend('image', image)
extend('size', size)

export default {
  name: 'ImageBlock',
  components: {
    PreviewImageInput,
    ValidationProvider
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.image-block {
  grid-column: auto / span 2;
  display: grid;
  padding: 10px;
  border: 1px solid #000;
  box-sizing: border-box;
  &_half {
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }
  &__image-wrapper {
    position: relative;
    padding-top: 56%;
    &_half {
      padding-top: 115%;
    }
  }
}
</style>